const styles = {
  global: {
    body: {
      color: 'text.main',
      letterSpacing: '0.01em',
    },
    label: {
      fontSize: '14px!important',
      fontWeight: 'normal!important',
    },
  },
};

export default styles;
